<template>
	<div class="d-flex align-center">
    <portal to="menu-w-backgrounds">
      <div
        v-if="menuOpen"
        class="overlay"
        @click="menuOpen = false"
      ></div>
    </portal>
		<v-menu
			v-model="menuOpen"
			bottom
			offset-y
			right
			min-width="650"
			max-width="650"
			content-class="container-notification-menu-header"
			:close-on-content-click="false"
			:close-on-click="false"
			@input="changeMenu"
		>
			<template v-slot:activator="{ on, attrs }">
				<v-btn
					icon
					dark
					small
					color="#959595"
					class="mr-2"
					v-bind="attrs"
					v-on="on"
				>
					<v-icon dark>mdi-cog-outline</v-icon>
				</v-btn>
			</template>
			<div class="white" style="position: relative;">
				<div dense class="px-2 py-1" style="background: #959595;">
					<p class="caption mb-0 font-weight-bold white--text">Configuración Tabla Correlativos</p>
				</div>
				<div class="pa-0">
					<v-tabs
						v-model="tab"
						background-color="#524D4D"
						grow
						dark
						height="40"
					>
						<v-tab><p class="mb-0 caption">Columnas Tabla</p></v-tab>
						<v-tab><p class="mb-0 caption">General Correlativos</p></v-tab>
						<v-tab><p class="mb-0 caption">Prefijos Informes</p></v-tab>
						<v-tab><p class="mb-0 caption">Prefijos Presupuestos</p></v-tab>
						<v-tabs-items v-model="tab">
							<v-tab-item>
								<div class="pa-2 white" v-if="serials_header_columns">
									<p class="mb-0 caption font-weight-bold">Selecciona las columnas a visualizar</p>
									<div class="px-2 pt-2 pb-4" style="max-height:400px;overflow-y: scroll;">
										<v-checkbox v-model="serials_header_columns.id" color="black" label="#" hide-details dense @change="changeColumnsSerials"></v-checkbox>
										<v-checkbox v-model="serials_header_columns.lp_id" color="black" label="# LP" hide-details dense @change="changeColumnsSerials"></v-checkbox>
										<v-checkbox v-model="serials_header_columns.client" color="black" label="Cliente" hide-details dense @change="changeColumnsSerials"></v-checkbox>
										<v-checkbox v-model="serials_header_columns.project" color="black" label="Proyecto" hide-details dense @change="changeColumnsSerials"></v-checkbox>
										<v-checkbox v-model="serials_header_columns.reports" color="black" label="Informes" hide-details dense @change="changeColumnsSerials('reports')"></v-checkbox>
										<div class="px-2" v-if="serials_header_columns">
											<v-checkbox
												v-for="prefix in prefixesReports"
												:key="prefix.id"
												:input-value="serials_header_columns.variable?.includes(prefix.id)"
												color="black"
												:label="prefix.name"
												hide-details dense
												@change="toggleVariableColumns(prefix, 'reports')"></v-checkbox>
										</div>
										<v-checkbox v-model="serials_header_columns.budgets" color="black" label="Presupuestos" hide-details dense @change="changeColumnsSerials('budgets')"></v-checkbox>
										<div class="px-2" v-if="serials_header_columns">
											<v-checkbox
												v-for="prefix in prefixesBudgets"
												:key="prefix.id"
												:input-value="serials_header_columns.variable?.includes(prefix.id)"
												color="black"
												:label="prefix.name"
												hide-details dense
												@change="toggleVariableColumns(prefix, 'budgets')"></v-checkbox>
										</div>
										<v-checkbox v-model="serials_header_columns.contracts" color="black" label="Contratos" hide-details dense @change="changeColumnsSerials"></v-checkbox>
									</div>
								</div>
							</v-tab-item>
							<v-tab-item>
								<div class="pa-4">
									<div class="caption d-flex align-center mb-0">Aquí puedes modificar el número inicial del correlativo de los documentos.</div>
									<div class="caption d-flex align-center mb-1">Ejemplo: 10 - PA <div class="example-serial mx-1">{{ baseSerial }}</div> - 2025</div>
									<div class="d-flex align-center">
										<v-text-field
											v-model="baseSerial"
											:loading="showLoading"
											outlined
											dense
											hide-details
											item-text="name"
											item-value="id"
											label="Número Base Para Correlativos"
											class="custom-height-search custom-height-calendar mt-2"
											color="#524D4D"
											@keypress="isNumberKey"
										></v-text-field>
									</div>
								</div>
							</v-tab-item>
							<v-tab-item>
								<div class="pa-4">
									<p class="mb-0 caption text-center" style="color: #524D4D">En esta sección podrás administrar los tipos de informe con los que tu empresa trabajará y que aparecerán en la tabla de correlativos</p>
									<div class="d-flex flex-row align-center justify-space-between my-2 mb-0 px-2">
										<p class="mb-0 font-weight-bold body-2" style="color: #524D4D">Prefijos para Informe</p>
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-btn icon color="grey" class="mr-3"
															v-bind="attrs"
															v-on="on"
															small
															@click="setBudgetPrefix(null, 'report')">
													<v-icon>mdi-plus</v-icon>
												</v-btn>
											</template>
											<span>Nuevo prefijo para Informe</span>
										</v-tooltip>
									</div>
									<v-divider class="my-2"></v-divider>
									<PrefixListingMenu :type="'report'" />
								</div>
							</v-tab-item>
							<v-tab-item>
								<div class="pa-4">
									<p class="mb-0 caption text-center" style="color: #524D4D">En esta sección podrás administrar los tipos de presupuesto con los que tu empresa trabajará y que aparecerán en la tabla de correlativos</p>
									<div class="d-flex flex-row align-center justify-space-between my-2 mb-0 px-2">
										<p class="mb-0 font-weight-bold body-2" style="color: #524D4D">Prefijos para Presupuesto</p>
										<!-- <div class="d-flex align-center">
											<p class="mb-0 font-weight-bold body-2" style="color: #524D4D">Prefijos para Presupuesto</p>
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-icon small
																v-bind="attrs"
																v-on="on"
																class="ml-2">mdi-information</v-icon>
												</template>
												<span>En esta sección podrás administrar los tipos de presupuesto con los que tu empresa trabajará</span>
											</v-tooltip>
											<p class="mb-0 caption" style="color: #524D4D">En esta sección podrás administrar los tipos de presupuesto con los que tu empresa trabajará</p>
										</div> -->
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-btn icon color="grey" class="mr-3"
															v-bind="attrs"
															v-on="on"
															small
															@click="setBudgetPrefix(null)">
													<v-icon>mdi-plus</v-icon>
												</v-btn>
											</template>
											<span>Nuevo prefijo para Presupuesto</span>
										</v-tooltip>
									</div>
									<v-divider class="my-2"></v-divider>
									<PrefixListingMenu :type="'budget'" />
								</div>
							</v-tab-item>
						</v-tabs-items>
					</v-tabs>
				</div>
			</div>
		</v-menu>
	</div>
</template>

<script>
import _debounce from 'lodash/debounce'
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import {updateCompanyConfig, getCompanyConfig} from '@/helpers/api/company'
import {removeBudgetPrefix, updateOrderPrefix} from '@/helpers/api/budgets'
import PrefixListingMenu from '@/components/Helpers/Components/PrefixListingMenu'

export default {
	name: 'SerialsTabletLeftButtons',
	components: {PrefixListingMenu},
	computed: {
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		},
		showLoading(){
			return this.loading
		},
		prefixes(){
			return this.$store.state.budget.companiesBudgetPrefixes
		},
		prefixesReports: {
			get() {
				return this.prefixes.filter(prefix => prefix.type === 'report')
			},
			set(newReports) {
				const updated = [
					...this.prefixes.filter(p => p.type !== 'report'),
					...newReports
				]
				this.$store.commit('budget/setCompaniesBudgetPrefixes', updated)
			}
		},
		prefixesBudgets: {
			get() {
				return this.prefixes.filter(prefix => prefix.type === 'budget')
			},
			set(newBudgets) {
				const updated = [
					...this.prefixes.filter(p => p.type !== 'budget'),
					...newBudgets
				]
				this.$store.commit('budget/setCompaniesBudgetPrefixes', updated)
			}
		}
	},
	watch: {
		selectedCompany(newValue){
			if(newValue){
				this.getConfigs()
			}
		},
		baseSerial(newValue, prevValue) {
			if(prevValue && newValue && newValue > 0 && !this.loading){
				this.onChangeBaseSerial()
			}
		}
	},
	data: () => ({
		serials_header_columns: null,
		menuOpen: false,
		tab: 1,
		loading: false,
		baseSerial: null
	}),
	mounted(){
		this.serials_header_columns = this.$store.state.budget.listingColumns
		if(this.selectedCompany){
			this.getConfigs()
			this.$store.dispatch('budget/getBudgetPrefixes')
		}
	},
	methods:{
		startEndDragPrefixReportEvent: _debounce(function(){ this.endDragPrefixReportEvent() }, 500),
		async endDragPrefixReportEvent(){
			const prefixes = this.prefixesReports.map((prefix, index) => {
				return {id: prefix.id, order: index + 1}
			})
			await updateOrderPrefix({prefixes})
			this.$store.dispatch('budget/getBudgetPrefixes')
		},
		startEndDragPrefixBudgetEvent: _debounce(function(){ this.endDragPrefixBudgetEvent() }, 500),
		async endDragPrefixBudgetEvent(){
			const prefixes = this.prefixesReports.map((prefix, index) => {
				return {id: prefix.id, order: index + 1}
			})
			await updateOrderPrefix({prefixes})
			this.$store.dispatch('budget/getBudgetPrefixes')
		},
		changeMenu(value){
			this.menuOpen = value
		},
		toggleVariableColumns(prefix, source = null) {
			let variable = []
			if(this.serials_header_columns?.variable){
				variable = [...this.serials_header_columns?.variable]
			}
			const index = variable?.indexOf(prefix.id);
			if (index === -1) {
				variable.push(prefix.id);
			} else {
				variable.splice(index, 1);
			}
			if (source === 'reports') {
				this.serials_header_columns.reports = variable.some(prefix_id =>
					this.prefixesReports.some(report => report.id === prefix_id)
				)
			}
			if (source === 'budgets') {
				this.serials_header_columns.budgets = variable.some(prefix_id =>
					this.prefixesBudgets.some(budget => budget.id === prefix_id)
				)
			}
			this.serials_header_columns = {...this.serials_header_columns, ...{variable}}
			this.$store.commit('budget/setListingColumns', this.serials_header_columns)
		},
		changeColumnsSerials(source = null){
			if (source === 'reports') {
				const newValue = this.serials_header_columns.reports
				let variable = this.serials_header_columns.variable
				if(newValue){
					const idsToAdd = this.prefixesReports.map(p => p.id);
					variable = Array.from(new Set([...variable, ...idsToAdd]));
				} else {
					const idsToRemove = new Set(this.prefixesReports.map(p => p.id));
					variable = variable.filter(id => !idsToRemove.has(id));
				}

				this.serials_header_columns = {...this.serials_header_columns, ...{variable}}
				this.$store.commit('budget/setListingColumns', this.serials_header_columns)
			}
			else if (source === 'budgets') {
				const newValue = this.serials_header_columns.budgets
				let variable = this.serials_header_columns.variable
				if(newValue){
					const idsToAdd = this.prefixesBudgets.map(p => p.id);
					variable = Array.from(new Set([...variable, ...idsToAdd]));
				} else {
					const idsToRemove = new Set(this.prefixesBudgets.map(p => p.id));
					variable = variable.filter(id => !idsToRemove.has(id));
				}

				this.serials_header_columns = {...this.serials_header_columns, ...{variable}}
				this.$store.commit('budget/setListingColumns', this.serials_header_columns)
			}
			else {
				const allReportsFalse = !this.serials_header_columns.vt_report &&
																!this.serials_header_columns.pp_report &&
																!this.serials_header_columns.pr_report;
				this.serials_header_columns.reports = !allReportsFalse;
			}

			this.$store.commit('budget/setListingColumns', this.serials_header_columns)
		},
		async getConfigs(){
			this.loading = true
			const config = await getCompanyConfig()
			if(config.code == 200){
				this.baseSerial = config.company_config?.base_serial
			}
			this.loading = false
		},
		onChangeBaseSerial: _debounce(function() { this.changeBaseSerial() }, 800),
		async changeBaseSerial(){
			if(this.loading) return

			this.loading = true
			const config = await updateCompanyConfig({
				base_serial: this.baseSerial
			})
			if(config.code == 200){
				eventBus.$emit('reloadInformation', {})
				// this.$refs.menuConfig.save()
				this.menuOpen = false
			}
			this.loading = false
		},
		isNumberKey(event) {
			const charCode = event.which ? event.which : event.keyCode;
			if (charCode < 48 || charCode > 57) {
				event.preventDefault();
			}
		},
		changeColumns(){
			this.$store.commit('reports/setListingColumns', this.reports_header_columns)
		},
		setBudgetPrefix(prefix = null, type = 'budget'){
			let newPrefix = {type}
			if(prefix){
				newPrefix = {
					...newPrefix,
					...prefix,
					...{budget_prefix_id: prefix.id}
				}
			}
			this.$store.commit('budget/setNewBudgetPrefixModalEditing', newPrefix)
      this.$store.commit('budget/setNewBudgetPrefixModal', true)
		},
		async deleteBugdetPrefix(prefix){
			await removeBudgetPrefix({budget_prefix_id: prefix.id})
			this.$store.dispatch('budget/getBudgetPrefixes')
		}
	}
}
</script>

<style>
.overlay {
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  z-index: 8; /* aseguramos que quede arriba */
  background-color: rgba(0, 0, 0, 0.2);
}
.example-serial{
	display: inline-block;
	background-color: rgba(0, 128, 0, 0.5);
	padding: 2px;
	width: 20px;
	height: 20px;
	text-align: center;
	aspect-ratio: 1;
	color: white;
	font-weight: bold;
	font-size: 14px;
	line-height: 14px;
	border-radius: 4px;
	border: 1px solid green;
}
	.handle_drag{
		cursor: move;
	}
</style>

<style scoped>
	.handle_drag{
		cursor: move;
	}
</style>